module.exports = __webpack_public_path__ + "static/media/facet-fire-security-icon.0c2b4fc9.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/icons/facet-fire-security-icon.png
// module id = 233
// module chunks = 0